import { useTranslation } from '@hooks/useTranslation';
import { IntegrationType } from '@models/integration.model';
import { Box, CircularProgress, Modal, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

interface GeneratingStructureLoadingModalProps {
  isOpen: boolean;
  integrationType?: IntegrationType;
}

const GeneratingStructureLoadingModal: React.FC<GeneratingStructureLoadingModalProps> = ({
  isOpen,
  integrationType,
}) => {
  const localeIntegrations = useTranslation('integrations');
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const messages =
    integrationType === IntegrationType.STORAGE
      ? [
          localeIntegrations['generatingStorageMessage1'],
          localeIntegrations['generatingStorageMessage2'],
          localeIntegrations['generatingStorageMessage3'],
          localeIntegrations['generatingStorageMessage4'],
          localeIntegrations['generatingStorageMessage5'],
        ]
      : [
          localeIntegrations['generatingCalendarMessage1'],
          localeIntegrations['generatingCalendarMessage2'],
          localeIntegrations['generatingCalendarMessage3'],
          localeIntegrations['generatingCalendarMessage4'],
          localeIntegrations['generatingCalendarMessage5'],
          localeIntegrations['generatingCalendarMessage6'],
        ];

  const title =
    integrationType === IntegrationType.STORAGE
      ? localeIntegrations['generatingStorageStructure']
      : localeIntegrations['generatingCalendarStructure'];

  useEffect(() => {
    if (!isOpen) {
      setCurrentMessageIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => Math.min(prev + 1, messages.length - 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [isOpen, messages.length]);

  return (
    <Modal open={isOpen} onClose={() => {}}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: 'center',
        }}>
        <CircularProgress size={60} className="mb-4" />
        <Typography variant="h6" component="h2" className="mb-4">
          {title}
        </Typography>
        <Typography variant="body14" color="text.secondary">
          {messages[currentMessageIndex]}
        </Typography>
      </Box>
    </Modal>
  );
};

export default GeneratingStructureLoadingModal;
